import { Bullet, Text } from "app/pages/website-analysis/TrafficAndEngagement/Components/StyledComponents";
import { WEB_SOURCE_DISPLAY_NAME } from "app/pages/website-analysis/TrafficAndEngagement/UtilityFunctionsAndConstants/UtilityFunctions";

export const PopSingleModeLegends = (props) => {
    const { webSource, chartType, legendItems, customLegends } = props;
    const Legends = legendItems.map((item, index) => (
        <Legend
            item={item}
            key={index}
            webSource={webSource}
            chartType={chartType}
            customLegends={customLegends}
        />
    ));
    return Legends;
};

const Legend = (props) => {
    const { item, webSource, chartType, customLegends } = props;
    const { name, color, transparentColor } = item;
    const allWebSources = ["Desktop", "Mobile web"];
    const webSources = webSource === "Total" && chartType === "column" && customLegends ? allWebSources : [webSource];
    return (
        <div>
            <Text color={color}>{name}</Text>
            {webSources.map((webSource, index) => (
                <WebSource
                    key={index}
                    webSource={webSource}
                    color={index === 0 ? color : transparentColor}
                />
            ))}
        </div>
    );
};

const WebSource = ({ color, webSource }) => {
    return (
        <Text>
            <Bullet background={color} />
            {WEB_SOURCE_DISPLAY_NAME[webSource] ? WEB_SOURCE_DISPLAY_NAME[webSource] : webSource}
        </Text>
    );
};
